// removed by extract-text-webpack-plugin
module.exports = {"contactForm":"src-components-ContactForm----contact-form-module---contactForm---3j-tL","input":"src-components-ContactForm----contact-form-module---input---2P5Ul","textarea":"src-components-ContactForm----contact-form-module---textarea---3BW2B","error":"src-components-ContactForm----contact-form-module---error---3awbY","button":"src-components-ContactForm----contact-form-module---button---2R3m6","message":"src-components-ContactForm----contact-form-module---message---1dfYw","errorMessage":"src-components-ContactForm----contact-form-module---errorMessage---2heX6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactForm/contact-form.module.css
// module id = 304
// module chunks = 35783957827783